import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Home, Briefcase, Newspaper, Mail } from 'lucide-react';

const styles = `
.nf-wrap { position: relative; min-height: calc(100vh - 5rem); display: flex; align-items: center; justify-content: center; overflow: hidden; background: #020617; }
.nf-glow-a { position: absolute; top: 20%; left: -8rem; width: 24rem; height: 24rem; border-radius: 9999px; background: rgba(59,130,246,0.10); filter: blur(64px); }
.nf-glow-b { position: absolute; bottom: 15%; right: -8rem; width: 24rem; height: 24rem; border-radius: 9999px; background: rgba(147,51,234,0.10); filter: blur(64px); }
.nf-inner { position: relative; z-index: 1; max-width: 40rem; margin: 0 auto; padding: 6rem 1.5rem; text-align: center; }
.nf-code { font-size: clamp(5rem, 18vw, 9rem); font-weight: 800; line-height: 1; letter-spacing: -0.04em; background: linear-gradient(to right, #60a5fa, #3b82f6, #9333ea); -webkit-background-clip: text; background-clip: text; -webkit-text-fill-color: transparent; margin: 0; }
.nf-title { font-size: clamp(1.5rem, 4vw, 2rem); font-weight: 700; color: #f1f5f9; margin: 1.25rem 0 0.75rem; }
.nf-text { color: #94a3b8; line-height: 1.7; margin: 0 auto 2.25rem; max-width: 30rem; }
.nf-btn { display: inline-flex; align-items: center; gap: 0.5rem; background: linear-gradient(to bottom, #1d4ed8, #3b82f6); color: #fff; padding: 0.75rem 1.5rem; border-radius: 0.6rem; font-weight: 700; text-decoration: none; transition: filter 0.2s; }
.nf-btn:hover { filter: brightness(1.12); }
.nf-links { margin-top: 2.75rem; padding-top: 1.75rem; border-top: 1px solid rgba(30,41,59,0.8); display: flex; flex-wrap: wrap; gap: 0.5rem 2rem; justify-content: center; }
.nf-link { display: inline-flex; align-items: center; gap: 0.4rem; font-size: 0.875rem; color: #64748b; text-decoration: none; transition: color 0.15s; }
.nf-link:hover { color: #60a5fa; }
`;

const suggestions = [
  { to: '/', label: 'Home', Icon: Home },
  { to: '/services', label: 'Services', Icon: Briefcase },
  { to: '/blog', label: 'Blog', Icon: Newspaper },
  { to: '/contact', label: 'Contact', Icon: Mail },
];

export default function NotFound() {
  return (
    <div className="nf-wrap">
      <style>{styles}</style>
      <div className="nf-glow-a" />
      <div className="nf-glow-b" />
      <div className="nf-inner">
        <p className="nf-code">404</p>
        <h1 className="nf-title">This page doesn't exist</h1>
        <p className="nf-text">
          The link may be out of date, or the address was mistyped. Everything else is still where you left it.
        </p>
        <Link to="/" className="nf-btn"><ArrowLeft size={16} /> Back to home</Link>

        <div className="nf-links">
          {suggestions.map(({ to, label, Icon }) => (
            <Link key={to} to={to} className="nf-link"><Icon size={14} /> {label}</Link>
          ))}
        </div>
      </div>
    </div>
  );
}
